/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BCMOsisRuleListConfiguration,
    BCMOsisRuleListConfigurationFromJSON,
    BCMOsisRuleListConfigurationToJSON,
    BCMOsisRuleListItem,
    BCMOsisRuleListItemFromJSON,
    BCMOsisRuleListItemToJSON,
    BCMOsisRuleListQuery,
    BCMOsisRuleListQueryFromJSON,
    BCMOsisRuleListQueryToJSON,
} from '../models';

export interface ApiBookingCreateManagerOsisBCMOsisRuleListDataPostRequest {
    bCMOsisRuleListQuery?: BCMOsisRuleListQuery;
}

export interface ApiBookingCreateManagerOsisBCMOsisRuleListDeleteDeleteRequest {
    id?: string;
}

/**
 * no description
 */
export class BCMOsisRuleListApi extends runtime.BaseAPI {

    /**
     */
    async apiBookingCreateManagerOsisBCMOsisRuleListConfigurationGetRaw(): Promise<runtime.ApiResponse<BCMOsisRuleListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/Osis/BCMOsisRuleList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BCMOsisRuleListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerOsisBCMOsisRuleListConfigurationGet(): Promise<BCMOsisRuleListConfiguration> {
        const response = await this.apiBookingCreateManagerOsisBCMOsisRuleListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerOsisBCMOsisRuleListDataPostRaw(requestParameters: ApiBookingCreateManagerOsisBCMOsisRuleListDataPostRequest): Promise<runtime.ApiResponse<Array<BCMOsisRuleListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/Osis/BCMOsisRuleList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BCMOsisRuleListQueryToJSON(requestParameters.bCMOsisRuleListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BCMOsisRuleListItemFromJSON));
    }

    /**
     */
    async apiBookingCreateManagerOsisBCMOsisRuleListDataPost(requestParameters: ApiBookingCreateManagerOsisBCMOsisRuleListDataPostRequest): Promise<Array<BCMOsisRuleListItem>> {
        const response = await this.apiBookingCreateManagerOsisBCMOsisRuleListDataPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerOsisBCMOsisRuleListDeleteDeleteRaw(requestParameters: ApiBookingCreateManagerOsisBCMOsisRuleListDeleteDeleteRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/Osis/BCMOsisRuleList/Delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBookingCreateManagerOsisBCMOsisRuleListDeleteDelete(requestParameters: ApiBookingCreateManagerOsisBCMOsisRuleListDeleteDeleteRequest): Promise<void> {
        await this.apiBookingCreateManagerOsisBCMOsisRuleListDeleteDeleteRaw(requestParameters);
    }

}
